<div
  [ngClass]="cssClass()"
  class="inline-flex size-12 items-center justify-center rounded-full border-[1px] border-gray-200 text-base text-white transition duration-300 hover:bg-white">
  <app-icon [icon]="icon()" />
</div>
